import React, { useContext } from 'react'
import Logo from '../../assets/logo/logo.svg';
import { Context } from '../../context/Context';
import './Loading.css';

/*
  Full-page loader by default. Pass `inline` when it sits inside a panel or
  modal body, so it sizes to the container instead of the viewport.
*/
export const Loading = ({ inline = false }) => {
    const { lang } = useContext(Context);

    return (
        <div
            className={`loading-container ${inline ? 'inline' : ''}`}
            role="status"
            aria-live="polite"
        >
            <div className="loader-overlay">
                <img src={Logo} alt="" aria-hidden="true" className="loader-logo" />
                <span className="loader-label">
                    {lang === 'ar' ? 'جارٍ التحميل…' : 'Loading…'}
                </span>
            </div>
        </div>
    )
}
